<template>
  <!-- <b-alert
    v-model="show"
    class="position-fixed fixed-bottom m-0 rounded-0"
    style="z-index: 999999"
    :variant="variant"
  >
    {{ message }}
  </b-alert> -->
  <div class="position-absolute top-0 start-50 translate-middle-x  p-3 mt-5" style="z-index: 999999">
    <div id="liveToast" ref="liveToast" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true">
      <div :class="['toast-body', variant] ">
        <i :class="toastIcon"></i>
          {{ message || "Something went wrong" }} 
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "base-alert",
  computed: {
    toastIcon() {
      const mapping = {
          'success': 'las la-check-circle la-2x me-3',
          'danger': 'las la-exclamation-circle la-2x me-3',
          'info': 'las la-info-circle la-2x me-3',
          'warning': 'las la-exclamation-circle la-2x me-3',
          'dark': 'las la-info-circle la-2x me-3'
      };
      return mapping[this.variant];
    },
    ...mapState({
      show: (state) => state.alerts.show,
      message: (state) => state.alerts.message,
      variant: (state) => state.alerts.variant,
    }),
  },
  watch: {
    show(newVal) {
      let toast = this.$refs.liveToast;
      if (newVal) {
        toast.classList.remove("hide");
        toast.classList.add("show");
      }
      else {
        toast.classList.add("hide");
        toast.classList.remove("show");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import './BaseAlert.scss';
</style>
